<template>
  <EMyIP :user-ip="userIp" />
</template>

<script>
export default {
  name: 'EMyIPWrapper',
  components: {
    EMyIP: async () => import(
      /* webpackChunkName: "my-ip" */
      './widget.vue'
    ),
  },
  props: {
    userIp: {
      type: String,
      required: true,
    },
  },
};
</script>
